import { faBookOpenReader, faBrain } from '@fortawesome/free-solid-svg-icons';
import PanelButton from 'view/components/common/PanelButton';

interface WritingIntroFormProps {
  onSelectWritingType: (isFreeform: boolean) => void;
}

const WritingAssignmentIntroForm: React.FC<WritingIntroFormProps> = ({
  onSelectWritingType,
}) => {
  return (
    <>
      <div className="reading-frame">
        <PanelButton
          label="Free form"
          icon={faBrain}
          hint="Enter a prompt, and have your students write up a response (e.g. reflections, essays, etc)."
          hintTitle="Writing assignment: Free form"
          onClick={() => onSelectWritingType(true)}
        />
        <PanelButton
          label="Comprehension"
          icon={faBookOpenReader}
          hint="Create a writing assignment that starts with a reading, testing student's writing and comprehension skills."
          hintTitle="Writing assignment: Comprehension"
          onClick={() => onSelectWritingType(false)}
        />
      </div>
    </>
  );
};

export default WritingAssignmentIntroForm;
